import { render, staticRenderFns } from "./EnergyConsumptionDetails.vue?vue&type=template&id=595532cd&scoped=true&"
import script from "./EnergyConsumptionDetails.vue?vue&type=script&lang=js&"
export * from "./EnergyConsumptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./EnergyConsumptionDetails.vue?vue&type=style&index=0&id=595532cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595532cd",
  null
  
)

/* custom blocks */
import block0 from "./EnergyConsumptionDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports